import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _LightTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { LightTheme5_3 } from "../LightTheme5_3";
import { themeTokens5_4 } from "../consts";
export var LightTheme5_4 = createTheme({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function LightTheme5_4() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(LightTheme5_4, _BasicThemeClassForEx);
    return LightTheme5_4;
  }(BasicThemeClassForExtension), _LightTheme5_.textareaMargin = themeTokens5_4.textareaMargin, _LightTheme5_.clearCrossIconWidthSmall = themeTokens5_4.clearCrossIconWidthSmall, _LightTheme5_.clearCrossIconWidthMedium = themeTokens5_4.clearCrossIconWidthMedium, _LightTheme5_.clearCrossIconWidthLarge = themeTokens5_4.clearCrossIconWidthLarge, _LightTheme5_.clearCrossIconAlign = themeTokens5_4.clearCrossIconAlign, _LightTheme5_.textareaVerticalAlign = themeTokens5_4.textareaVerticalAlign, _LightTheme5_),
  prototypeTheme: LightTheme5_3,
  themeMarkers: [markThemeVersion('5.4')]
});